import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useUIStore = create(
  persist(
    (set, get) => ({
      // Sidebar states
      leftSidebarCollapsed: false,
      rightSidebarCollapsed: true,
      mobileMenuOpen: false,

      // Active document for right sidebar context
      activeDocumentId: null,

      // Theme - light mode as default
      theme: 'light',

      // Page layout preference for PageEditor
      preferredPageLayout: 'single-image', // 'book', 'single-image', 'single-text'

      // Document history (recent documents)
      recentDocuments: [],
      maxRecentDocuments: 10,

      // Actions
      toggleLeftSidebar: () => set((state) => ({
        leftSidebarCollapsed: !state.leftSidebarCollapsed
      })),

      toggleRightSidebar: () => set((state) => ({
        rightSidebarCollapsed: !state.rightSidebarCollapsed
      })),

      setLeftSidebarCollapsed: (collapsed) => set({
        leftSidebarCollapsed: collapsed
      }),

      setRightSidebarCollapsed: (collapsed) => set({
        rightSidebarCollapsed: collapsed
      }),

      toggleMobileMenu: () => set((state) => ({
        mobileMenuOpen: !state.mobileMenuOpen
      })),

      closeMobileMenu: () => set({ mobileMenuOpen: false }),

      openMobileMenu: () => set({ mobileMenuOpen: true }),

      setActiveDocument: (id) => set({ activeDocumentId: id }),

      // Add document to recent history
      addRecentDocument: (document) => set((state) => {
        const filtered = state.recentDocuments.filter(
          (doc) => doc.id !== document.id
        );
        const updated = [
          {
            id: document.id,
            title: document.title || `Document ${document.id}`,
            thumbnail: document.thumbnail,
            status: document.is_processed ? 'processed' : document.has_error ? 'failed' : 'pending',
            accessedAt: new Date().toISOString(),
          },
          ...filtered,
        ].slice(0, state.maxRecentDocuments);
        return { recentDocuments: updated };
      }),

      removeRecentDocument: (id) => set((state) => ({
        recentDocuments: state.recentDocuments.filter((doc) => doc.id !== id)
      })),

      clearRecentDocuments: () => set({ recentDocuments: [] }),

      // Theme toggle (for future use)
      setTheme: (theme) => set({ theme }),
      toggleTheme: () => set((state) => ({
        theme: state.theme === 'dark' ? 'light' : 'dark'
      })),

      // Page layout preference
      setPreferredPageLayout: (layout) => set({ preferredPageLayout: layout }),
    }),
    {
      name: 'lensverse-ui-storage',
      partialize: (state) => ({
        leftSidebarCollapsed: state.leftSidebarCollapsed,
        rightSidebarCollapsed: state.rightSidebarCollapsed,
        recentDocuments: state.recentDocuments,
        theme: state.theme,
        preferredPageLayout: state.preferredPageLayout,
      }),
    }
  )
);

export default useUIStore;
